import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";

const FactoryAutomationVideoCard_3 = () => {
  return (
    <div className="card w-50 h-auto">
      <div className="card-body bg-dark text-white">
        <h5 className="card-title">Automatic Ultrasonic Welding Line</h5>
        <p className="card-text">
          This project was one of the most challenging projects I have ever managed, time and budget were very tight.
          Lots of engineering resources were involved, and the result was a very successful project.
        </p>

        <h6>
          Investment: <span>$900,000 USD</span>
        </h6>
        <h6>
          Time to build: <span>8 months</span>
        </h6>
        <h6>
          Savings: <span>Only one DL requiered for 7 stations</span>
        </h6>
        <h6>
          Technology: <span>Full Automatic Line, 8 Stations, Robots, Visions systems, Bowl Feeders, Ultrasonic Welding</span>
        </h6>
      </div>
    </div>
  );
};

export default FactoryAutomationVideoCard_3;
